import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';
import qs from 'qs';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import { CHAT_SETTINGS_URL } from 'webchat/Api';
import ApiService from 'services/ApiService/ApiService';


const APPLY_CHAT_SETTINGS = 'cam4/chat/APPLY_CHAT_SETTINGS';
const CHANGE_CHAT_SETTINGS = 'cam4/chat/CHANGE_CHAT_SETTINGS';

const initialState = Immutable.fromJS({
  chatSettings: {
    fullScreenFontSize: 18,
    normalScreenFontSize: 16,
    allowMyLanguage: false,
    receiveGoldEnterNotification: true,
    allowGender: false,
  },
});

export const NAME = 'chat';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case APPLY_CHAT_SETTINGS:
      return state.set('chatSettings', Immutable.fromJS(action.chatSettings));
    case CHANGE_CHAT_SETTINGS: {
      const settingsModified = Object.keys(action.chatSettings)[0];

      return state.setIn(['chatSettings', settingsModified], action.chatSettings[settingsModified]);
    }
    default:
      return state;
  }
}

const chatSettings = (state) => state[NAME].get('chatSettings');

function applySettings(chatSettings) {
  delete chatSettings.accessHash;
  delete chatSettings.username;
  delete chatSettings.roomName;

  return {
    type: APPLY_CHAT_SETTINGS,
    chatSettings,
  };
}

function getChatSettings(myUserName) {
  return (dispatch) =>
    ApiService.get(CHAT_SETTINGS_URL.concat(`?userName=${myUserName}`))
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          dispatch(applySettings(res.data));
        }
      })
      .catch((err) => logger.error(err));
}

function changeSettings(chatSettings) {
  delete chatSettings.accessHash;
  delete chatSettings.username;
  delete chatSettings.roomName;

  return {
    type: CHANGE_CHAT_SETTINGS,
    chatSettings,
  };
}

function setChatSettings(settings) {
  const headers = { 'content-type': 'application/x-www-form-urlencoded' };
  const data = qs.stringify(settings);

  return (dispatch) =>
    ApiService.post(CHAT_SETTINGS_URL, { data, headers })
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          const decodedData = JSON.parse(
            `{"${
              decodeURI(res.config.data)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"')
                .replace(/"false"/g, 'false')
                .replace(/"true"/g, 'true')
                .replace(/"(\d+)"/g, '$1')
            }"}`
          );
          dispatch(changeSettings(decodedData));
        }
      })
      .catch((err) => logger.error(err));
}

export const selector = createStructuredSelector({ chatSettings });

export const actionCreators = {
  getChatSettings,
  setChatSettings,
};
